import React, { useEffect } from 'react';
import PublicHeader from '../../components/common/PublicHeader';
import PublicFooter from '../../components/common/PublicFooter';
const AffiliatesPage = () => {
  const affiliatedAssociations = [
    {
      sno: 1,
      name: "Assam Baseball Association",
      address: "C/o Sultana Rahman, Rahman Building (2nd flr)\nOpp. Rihno Club, Asram Road\nSouth Sarania, Ulubari, Guwahati-7",
      president: "Dr.Nazrul Islam",
      secretary: "Ms. Ashma Begum",
      regNo: "Pending",
      afflDist: "18",
      contact: "(M) 94350-89530",
      email: "ashma5asm@yahoo.co.in"
    },
    {
      sno: 2,
      name: "Andhra Pradesh Baseball Association",
      address: "F. No. 305,,uniteflora apartment, j. K. Colony, Gandhinagar, Nellore- 524004, A.P.",
      president: "Mr. L. Pavan Kumar Reddy",
      secretary: "Mr. S. Mallikarjun Reddy",
      regNo: "207/2018",
      afflDist: "13",
      contact: "9440843022\n7989115225",
      email: "andhrapradeshbaseball2018@gmail.com"
    },
    {
      sno: 3,
      name: "Baseball Association of Bihar",
      address: "Guru Niwas, Kun kun Singh lane, Patna 800006, Bihar.",
      president: "Mr. Promod Sharma",
      secretary: "Mr. Ajay Sharma",
      regNo: "S22385",
      afflDist: "27",
      contact: "0612-2687832\n(M) 09334079252",
      email: "ansbca@gmail.com"
    },
    {
      sno: 4,
      name: "Baseball Association Chandigarh",
      address: "H.No.923,Sector - 7, Chandigarh.",
      president: "Mr. Jaspal Singh",
      secretary: "Mr. Kiran Rampal",
      regNo: "1935 of 1991",
      afflDist: "UT",
      contact: "0172-2795871\n(M) 09466077399",
      email: "kiranramp@gmail.com"
    },
    {
      sno: 5,
      name: "Chhattisgarh Baseball Association",
      address: "H.No. 243 Ward No.-38Hemu Nagar,\nBilaspur, Chhattisgarh.",
      president: "Mr. Shailesh Pandey",
      secretary: "Ms. Mitali Ghosh",
      regNo: "2567 of 2009",
      afflDist: "15",
      contact: "07752-256189\n(M) 09827153028",
      email: "cgabaseball@gmail.com"
    },
    {
      sno: 6,
      name: "Baseball Association Delhi",
      address: "B-IV/317B, Keshav Puram,New Delhi-110035.",
      president: "Dr. Bhagat Singh",
      secretary: "Mr. Virender Bhardwaj",
      regNo: "S/15170 of 1985",
      afflDist: "UT",
      contact: "011-27519327\n011-27180043\n(M)09891489459",
      email: "sportstms@yahoo.co.in"
    },
    {
      sno: 7,
      name: "Amateur Baseball Federation of Goa",
      address: "2, Durga Apartments,Luis Miranda Road,\nMargao - Goa - 403601.",
      president: "Mr. Ramakant S. Angle",
      secretary: "Minanath Upathaye",
      regNo: "-",
      afflDist: "-",
      contact: "09822100651",
      email: "ramakantangle@rediffmail.com"
    },
    {
      sno: 8,
      name: "Gujrat State Baseball Association",
      address: "818/331, Laxmi Pura,O/S Raipur Gate, Near Ankur Mills,Ahemdabad - 380002",
      president: "Mr. Mahesh Kasvala",
      secretary: "Mr. J.K Khodadhra",
      regNo: "Guj/1153 of 1986",
      afflDist: "18",
      contact: "079-25384150\n(M) 09327050344",
      email: "jkkhodadhra@yahoo.com"
    },
    {
      sno: 9,
      name: "H.P. Baseball Association",
      address: "Saroj Hosiery, Chamba Ghat, Solan - 173213",
      president: "Dr. Sudhir Mohindru",
      secretary: " ",
      regNo: "-",
      afflDist: "-",
      contact: "9816030191",
      email: "sudhirmohindru@gmail.com"
    },
    {
      sno: 10,
      name: "Haryana Baseball Association",
      address: "Opposite 191-L, Model Town,Rohtak-124001.",
      president: "Mr. Dharambir Singh",
      secretary: "Mr. Arvind Kumar",
      regNo: "363",
      afflDist: "14",
      contact: "01262-211695\n01262-211248\n(M) 09813172041",
      email: "balharaharsh@gmail.com"
    },
    {
      sno: 11,
      name: "Jammu & Kashmir Baseball Association",
      address: "Near Ziyarat Shareef Awantipora, Pulwama, Kashmir - 192122",
      president: "Mr. Raju Sharma",
      secretary: "Mr. Farooq Ahmad",
      regNo: "5835-S of 2009",
      afflDist: "15",
      contact: "09419183477 09596337442",
      email: "jkbaseballassociation@gmail.com"
    },
    {
      sno: 12,
      name: "Jharkhand Baseball Association",
      address: "R. M. C. H. Bariatu Birsa Blood Bank,Ranchi - 834009",
      president: "Mr. Jai Kumar Sinha",
      secretary: "Mr. Bijay Shankar Singh",
      regNo: "-",
      afflDist: "-",
      contact: "(M)9934395196",
      email: "v528913@gmail.com"
    },
    {
      sno: 13,
      name: "Kerala Baseball Association",
      address: "'Taas' TC 7/168/1, Karithodu Lane, Kanji Ram Para P.O. Thirvanthapuram - 950030.",
      president: "Mr. M. N. Krishnamurthy",
      secretary: "Anand Lal TP",
      regNo: "T1297/08",
      afflDist: "12",
      contact: "4842216113\n(M)9856076113",
      email: "baseballkerala@gmail.com"
    },
    {
      sno: 14,
      name: "Baseball Association of Karnataka",
      address: "Mpee Enterprises, Sujata Complex,2nd Floor, 1-Main Gandhi Nagar, Bangalore-560007",
      president: "Mr. Ashok Patan",
      secretary: "Mr. Anil Ram Chandra",
      regNo: "-",
      afflDist: "-",
      contact: "080-23330199\n(M)09449708776",
      email: "kbaseball@gmail.com"
    },
    {
      sno: 15,
      name: "Manipur Baseball Association",
      address: "Yaiskul, Jamnasthan,Leikai, Imphal-795001.",
      president: "Mr. T. B. Singh",
      secretary: "Mr. Indukiran Singh",
      regNo: "30/SR/Manipur of 97",
      afflDist: "5",
      contact: "(M)09856088366",
      email: "achomindu@yahoo.com"
    },
    {
      sno: 16,
      name: "M.P.A. Baseball Association",
      address: "42, Shankar Bagh Colony, Near Mari Mata Chowk, Indore - 452002.",
      president: "Mrs. Malini Gaud",
      secretary: "Mr. Jasraj Mehta",
      regNo: "26733 of 1995",
      afflDist: "15",
      contact: "0731-2420590\n(M)09425054865",
      email: "meprakash22@yahoo.co.in"
    },
    {
      sno: 17,
      name: "Maharashtra Baseball Association",
      address: "6,Sangvi Chawl, New Maneklal Estet, Narsi Mehata Road, Near Dattamandir, Ghatkopar (west), Mumbai 400086.",
      president: "Mr. Jitendra Ahawad",
      secretary: "Mr. Rajendra Ikhankar",
      regNo: "F/9334",
      afflDist: "28",
      contact: "(M)09833321882\n022-25346969\n022-25348282",
      email: "rikhankar@yahoo.com"
    },
    {
      sno: 18,
      name: "Baseball Association of Odisha",
      address: "Telenga Bazar,Cuttack - 753009 (Odisha)",
      president: "Mr. Vijay Khandelwal",
      secretary: "Mr. S.N. Pradhan",
      regNo: "6379/151 of 1989",
      afflDist: "21",
      contact: "0671-2625780\n(M)09437025780",
      email: "pradhansibananda@yahoo.com"
    },
    {
      sno: 19,
      name: "Punjab Baseball Association",
      address: "180 Atam Nagar, Ludhiana - 141002 (Punjab)",
      president: "Mr. S.Sukhdev Singh Aulakh",
      secretary: "Mr. Harbir Singh Gill",
      regNo: "418 of 1986",
      afflDist: "18",
      contact: "(M)9815337030\n(M)9814100626",
      email: "Punjabstatebaseballassociation@gmail.com"
    },
    {
      sno: 20,
      name: "Amateur Baseball Association of Pondicherry",
      address: "No. 12 First Cross, Kolas Nagar, Pondicherry - 605001",
      president: "Mr. P. Naryana Swami",
      secretary: "Mr. V. Ilangovane",
      regNo: "61/2000",
      afflDist: "UT",
      contact: "0413-372171\n0413-357829",
      email: "elanko79@gmail.com"
    },
    {
      sno: 21,
      name: "Rajasthan Baseball Association",
      address: "Odd. Bus dept. near Gulab AAta Chaki, Ward no 44, Devipura Sikar Distic",
      president: "Ashok Kumar Sharma",
      secretary: "Omprakash Mahala",
      regNo: "Applied",
      afflDist: "23",
      contact: "09672737888\n09414292672",
      email: "opmahala0364@gmail.com\nashok.advocate17@gmail.com"
    },
    {
      sno: 22,
      name: "Tamilnadu Baseball Association",
      address: "No: 19, 3B, Quanta Ranjini apartments, Rajarathinam Street, Kilpauk, Chennai - 600010",
      president: "-",
      secretary: "Mr. S. Venkat",
      regNo: "-",
      afflDist: "-",
      contact: "044-28173639\n044-22456480\n(M)09444066655",
      email: "tnba.chennai@yahoo.co.in"
    },
    {
      sno: 23,
      name: "Baseball Association of Telangana",
      address: "103 - Dhanni Apt. 17-1-388/5/B&c Beside BSNL Office, Laxmi Nagar, Saidabad Hyderabad-500059",
      president: "T Nitesh Reddy",
      secretary: "Ms. Shweta",
      regNo: "933 of 2014",
      afflDist: "27",
      contact: "+91 9899599088",
      email: "baseballtelangana@gmail.com"
    },
    {
      sno: 24,
      name: "Uttrakhand Baseball Association",
      address: "",
      president: "Mr. Vimal Harnal",
      secretary: "Mr. Satish Anand",
      regNo: "-",
      afflDist: "-",
      contact: "9837187602\n9456751857",
      email: "satishanand54@gmail.com"
    },
    {
      sno: 25,
      name: "U.P State Baseball Association",
      address: "Vedant College of Education, Garhmukteshwar, Ghaziabad.",
      president: "Dr. D. R. Yadav",
      secretary: "Mr. Dinesh Yadav",
      regNo: "41128-M of 2001",
      afflDist: "16",
      contact: "05761-2796609\n05761-2796566\n(M)09412223344",
      email: "mdvedantgroups@gmail.com"
    },
    {
      sno: 26,
      name: "Bengal Baseball Association",
      address: "11/11 Kalicharan Ghosh Road, Kolkata - 700050",
      president: "Mr. Ajoy Ghosh",
      secretary: "Mr. Ashis Bardhan",
      regNo: "S/1L/53701 of 2008",
      afflDist: "11",
      contact: "033-25463300\n(M)09831128271",
      email: "jaharmumdas@hotmail.com"
    }
  ];

  const zones = {
    north: {
      name: "NORTH ZONE",
      states: ["Jammu & Kashmir", "Himachal Pradesh", "Punjab, Chandigarh", "Haryana"]
    },
    south: {
      name: "SOUTH ZONE", 
      states: ["Andhra Pradesh", "Tamilnadu", "Telangana", "Karnataka", "Pondichery", "Kerala"]
    },
    central: {
      name: "CENTRAL ZONE",
      states: ["Delhi", "Uttar Pradesh", "Uttranchal", "Rajasthan"]
    },
    west: {
      name: "WEST ZONE",
      states: ["Goa", "Gujrat", "Chattisgarh", "Maharashtra", "Madhya Pradesh"]
    },
    east: {
      name: "EAST ZONE",
      states: ["Bihar", "West Bengal", "Orissa", "Jharkhand", "Manipur"]
    },
    northeast: {
      name: "NORTH EAST ZONE",
      states: ["Assam", "Tripura", "Meghalaya"]
    }
  };

  useEffect(() => {
    // Load external stylesheets
    const stylesheets = [
      'https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css',
      'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css',
      '/css/screen_layout_mega.css',
      '/css/default.css',
      '/css/component.css',
      '/css/slimmenu.css'
    ];

    stylesheets.forEach(href => {
      if (!document.querySelector(`link[href="${href}"]`)) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        document.head.appendChild(link);
      }
    });

    // Load external scripts
    const scripts = [
      '/js/jquery.min.js',
      '/js/jquery.slimmenu.js'
    ];

    let scriptsLoaded = 0;
    scripts.forEach(src => {
      if (!document.querySelector(`script[src="${src}"]`)) {
        const script = document.createElement('script');
        script.src = src;
        script.onload = () => {
          scriptsLoaded++;
          if (scriptsLoaded === scripts.length) {
            // Initialize slimmenu after all scripts are loaded
            setTimeout(() => {
              if (window.$ && window.$('ul.slimmenu').length > 0) {
                window.$('ul.slimmenu').slimmenu({
                  resizeWidth: '1100',
                  collapserTitle: 'Main Menu',
                  easingEffect: 'easeInOutQuint',
                  animSpeed: 'medium',
                  indentChildren: true,
                  childrenIndenter: '&raquo;'
                });
              }
            }, 500);
          }
        };
        document.head.appendChild(script);
      }
    });

    // Set page title
    document.title = 'Affiliated Associations | SportsTMS | THE OFFICIAL SPORTS MANAGEMENT SYSTEM';
  }, []);

  return (
    <div id="outer_m">
      {/* Header */}
        <PublicHeader />

      {/* Main Content */}
      <div id="main">
        {/* Social Media Sticky Icons */}
        <div id="stickleft">
          <i className="fa fa-facebook-square" style={{fontSize: '32px', marginLeft: '2px', cursor: 'pointer', color: '#2d3e50'}}></i>
          <i className="fa fa-youtube-square" style={{fontSize: '32px', marginLeft: '2px', cursor: 'pointer', color: '#2d3e50'}}></i>
          <i className="fa fa-twitter-square" style={{fontSize: '32px', marginLeft: '2px', cursor: 'pointer', color: '#2d3e50'}}></i>
          <i className="fa fa-linkedin-square" style={{fontSize: '32px', marginLeft: '2px', cursor: 'pointer', color: '#2d3e50'}}></i>
        </div>

        {/* Affiliates Table */}
        <div className="container" style={{marginTop: '50px'}}>
          <div className="row">
            <div className="col-lg-12">
              <div className="panel panel-default">
                <div className="panel-heading">
                  <center>
                    <label className="bol">List of Affiliated baseball Association of Amateur Baseball Federation if India</label>
                  </center>
                </div>
                <div className="panel-body">
                  <div className="table-responsive">
                    <table className="table table-striped table-bordered table-hover">
                      <thead>
                        <tr>
                          <th>S.No.</th>
                          <th>Name & Address</th>
                          <th>President</th>
                          <th>Secretary</th>
                          <th>Reg. No.</th>
                          <th>Affl. Dist.</th>
                          <th>Contact No.</th>
                          <th>Email</th>
                        </tr>
                      </thead>
                      <tbody>
                        {affiliatedAssociations.map((association) => (
                          <tr key={association.sno}>
                            <td>{association.sno}</td>
                            <td>
                              <b>{association.name}</b><br />
                              {association.address.split('\n').map((line, index) => (
                                <span key={index}>{line}<br /></span>
                              ))}
                            </td>
                            <td>{association.president}</td>
                            <td>{association.secretary}</td>
                            <td>{association.regNo}</td>
                            <td>{association.afflDist}</td>
                            <td>
                              {association.contact.split('\n').map((line, index) => (
                                <span key={index}>{line}<br /></span>
                              ))}
                            </td>
                            <td>
                              {association.email.split('\n').map((line, index) => (
                                <span key={index}>{line}<br /></span>
                              ))}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Zone-wise List */}
        <div className="container" style={{marginTop: '50px'}}>
          <div className="row">
            <center>
              <label className="bol"><br />LIST OF AFFILIATED UNITS ZONE WISE</label>
            </center>
            <hr />
            
            {Object.entries(zones).map(([key, zone]) => (
              <div key={key} className="col-lg-2">
                <div className="list-group">
                  <li className="list-group-item active"><b>{zone.name}</b></li>
                  {zone.states.map((state, index) => (
                    <li key={index} className="list-group-item">{state}</li>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Footer */}
      <PublicFooter />
    </div>
  );
};

export default AffiliatesPage;